import { matchPath } from "@remix-run/react";

/**
 * Active state for sidebar / mobile general nav links.
 * Marketplace uses prefix match but must not light up on publisher routes under `/u/marketplace/my-listings`.
 */
export function isGeneralNavLinkActive(
  linkTo: string,
  pathname: string,
): boolean {
  if (linkTo === "/u/marketplace") {
    return (
      pathname.startsWith("/u/marketplace") &&
      !pathname.startsWith("/u/marketplace/my-listings")
    );
  }
  return Boolean(
    matchPath({ path: linkTo, caseSensitive: false, end: false }, pathname),
  );
}
